const ALWAYS = 'always';
const PUBLIC = 'public';
const SHARED = 'shared';
const NEVER = 'never';

import _ from 'lodash';

/**
 * some FE fix for BE models having different model associates/owner structure
 **/
function isClientPortal() {
    return window.packageBuild === 'cp';
}

function hasConsultants(model) {
    return model && model.consultants && _.isObject(model.consultants);
}

function isCp(model) {
    return isClientPortal() && hasConsultants(model);
}

function cp_isConsultantsGroupUser(user, model, groups = ['users', 'officeGroups', 'regions']) {
    return model
        ? groups.some(type => {
            return model.consultants?.[type] || []
                .some(group => (group.users
                    ? group.users.map(({ id }) => id)
                    : [group.id]
                ).includes(user.id));
        })
        : false;
}
/**
 *
 **/

function isSecondaryOwnerUser(user, model, groups = ['user', 'officeGroup', 'region']) {
    return isOwner(user, model, groups)
        && !isPrimaryOwnerUser(user, model);
}

function isOwner(user, model, groups = ['user', 'officeGroup', 'region']) {
    return !!model && (model.owners || [])
        .filter(({ type }) => groups.includes(type))
        .flatMap(({ model }) => model.user_ids || model.id)
        .includes(user.id);
}

function isPrimaryOwnerUser(user, model) {
    return !!model
        && (model.owner?.model?.id
            || model.owner?.id) // fix for all old models
            === user.id;
}

function hasOwnerPermissions(user, model) {
    return isCp(model)
        ? cp_isConsultantsGroupUser(user, model) || isPrimaryOwnerUser(user, model)
        : isOwner(user, model);
}

function isPublic(model) {
    return !_(model).has('private') || !model.private;
}

function isCategory99(firm) {
    return _(firm).get('category', 1) === 99;
}

function hasPermission(permission, model, user, type) {
    switch (permission) {
        case NEVER:
        case false:
            return false;
        case ALWAYS:
        case true:
            return true;
        case PUBLIC:
            return isPublic(model)
                || hasOwnerPermissions(user, model);
        case SHARED:
            if (!model && type === 'compliance') {
                return true;
            }
            return hasOwnerPermissions(user, model);
        default:
            return false;
    }
}

function getPermissionGroupFor(user) {
    if (!user) {
        return null;
    }
    if (!_.isObject(user.permissionGroup)) {
        let group = _.find(window.nal.firm.permission_groups, ['id', user.permissionGroup]);
        user.permissionGroup = group || user.permissionGroup;
    }
    return user.permissionGroup;
}

function getPermissionsFor(user) {
    let permissions = getPermissionGroupFor(user);
    return permissions && permissions.allPermissions;
}

function getPermissionFor(user, type, action) {
    return getPermissionsFor(user)[type][action];
}

function allowed(action, type, model, user) {
    const permissionsFor = getPermissionsFor(user);
    if (!permissionsFor || !permissionsFor[type] || !permissionsFor[type][action]) {
        return false;
    }
    return hasPermission(permissionsFor[type][action], model, user, type);
}

function buildAuthFunctions(type) {
    // Pre populate the type and action arguments in the allowed function
    function typeCan(action) {
        return _.partial(allowed, action, type);
    }

    const authFunctions = {};

    // Loop through all the permissions for that type and create a function from
    // the value. If the value is a boolean the function just returns that
    // boolean (_.constant). If not we create the modified hasPermission
    // function for that action.
    let permissions = nal.permissions;
    if (permissions) {
        _.keys(permissions[type]).forEach(action => {
            authFunctions[_.camelCase(action)] = typeCan(action);
        });
    }

    return authFunctions;
}

export {
    allowed,
    isOwner,
    isSecondaryOwnerUser,
    isPrimaryOwnerUser,
    hasPermission,
    buildAuthFunctions,
    getPermissionFor,
    getPermissionsFor,
    getPermissionGroupFor,
    isCategory99,
    hasOwnerPermissions,
};
